import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";

const Suggestion = () => {
  const navigate = useNavigate();
  const grage_id = localStorage.getItem("grage_id");
  const server_url = localStorage.getItem("server_url");
  const company_id = localStorage.getItem("company_id") || "2";

  const [formData, setFormData] = useState({
    suggestion_title: "",
    suggestion_description: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Check if user is logged in
  useEffect(() => {
    if (!grage_id || !server_url) {
      toast.error("Please login to access suggestions");
      navigate("/login");
    }
  }, [navigate, grage_id, server_url]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    const newErrors = {};
    if (!formData.suggestion_title.trim()) {
      newErrors.suggestion_title = "Title is required";
    }
    if (!formData.suggestion_description.trim()) {
      newErrors.suggestion_description = "Description is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        company_id: company_id,
        grage_id: grage_id,
        suggestion_title: formData.suggestion_title,
        suggestion_description: formData.suggestion_description,
      };

      const formDataToSend = new URLSearchParams();
      for (const key in payload) {
        formDataToSend.append(key, payload[key]);
      }

      const response = await axios.post(
        `${server_url}suggestion.php`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      if (response.data.status === "1") {
        toast.success("Suggestion submitted successfully!");

        // Reset form
        setFormData({
          suggestion_title: "",
          suggestion_description: "",
        });
        setErrors({});
      } else {
        toast.error(response.data.error || "Failed to submit suggestion");
      }
    } catch (error) {
      console.error("Submit suggestion error:", error);
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else if (error.response?.status === 404) {
        toast.error("Suggestion endpoint not found. Check server URL.");
      } else {
        toast.error("Unable to connect to server. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <style jsx>{`
        .login-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          padding: 20px;
        }

        .login-form-container {
          background: white;
          border-radius: 15px;
          box-shadow: 3px 3px 20px 0px #00000036;
          overflow: hidden;
          width: 100%;
          max-width: 500px;
        }

        .login-form-wrapper {
          padding: 10px;
        }

        .login-logo {
          text-align: center;
          margin-bottom: 1.5rem;
        }

        .logo-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto 1rem;
          background: linear-gradient(135deg, #0352a1 0%, #0352a1 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo-icon img {
          width: 40px;
          height: 40px;
          filter: brightness(0) invert(1);
        }

        .login-logo h2 {
          color: #333;
          margin: 0 0 0.5rem 0;
          font-size: 1.5rem;
        }

        .login-logo p {
          color: #666;
          margin: 0;
          font-size: 13px;
        }

        .login-form {
          margin-top: 1.5rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-group label {
          text-align: left;
          display: block;
          margin-bottom: 8px;
          font-weight: 600;
          color: #333;
          font-size: 0.9rem;
        }

        .input-group {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          left: 15px;
          color: #666;
          z-index: 2;
        }

        .form-input {
          width: 100%;
          padding: 12px 15px 12px 45px;
          border: 2px solid #e1e5e9;
          border-radius: 8px;
          font-size: 14px;
          transition: all 0.3s ease;
          background: #fafbfc;
        }

        .form-input:focus {
          outline: none;
          border-color: #667eea;
          background: white;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .form-input.error {
          border-color: #e74c3c;
        }

        textarea.form-input {
          resize: vertical;
          min-height: 100px;
          font-family: inherit;
        }

        .error-message {
          color: #e74c3c;
          font-size: 0.8rem;
          margin-top: 5px;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .login-button {
          width: 100%;
          padding: 12px;
          background: linear-gradient(135deg, #0352a1  0%, #0352a1  100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .login-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
        }

        .login-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .success-message {
          background: #d4edda;
          color: #155724;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 1rem;
          text-align: center;
          border: 1px solid #c3e6cb;
        }

        .garage-info {
          background: #e7f3ff;
          color: #0066cc;
          padding: 10px;
          border-radius: 8px;
          margin-bottom: 1rem;
          text-align: center;
          font-size: 0.9rem;
          border: 1px solid #b3d9ff;
        }

        @media (max-width: 768px) {
          .login-form-wrapper {
          }

          .login-form-container {
                  padding: 0.5rem;
          }
        }
      `}</style>

      {/* Form Container */}
      <div className="login-form-container">
        <div className="login-form-wrapper">
          {/* Logo */}
          <div className="login-logo">
            <div className="logo-icon">
              <i
                className="fas fa-lightbulb"
                style={{ color: "white", fontSize: "2rem" }}
              ></i>
            </div>
            <h2>Customer Suggestions</h2>
            <p>Share your feedback and suggestions with us</p>
          </div>

          {/* Suggestion Form */}
          <form className="login-form" onSubmit={handleSubmit}>
            {/* Suggestion Title */}
            <div className="form-group">
              <label>Suggestion Title *</label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-heading"></i>
                </div>
                <input
                  type="text"
                  name="suggestion_title"
                  className={`form-input ${
                    errors.suggestion_title ? "error" : ""
                  }`}
                  placeholder="Enter a title for your suggestion"
                  value={formData.suggestion_title}
                  onChange={handleChange}
                  maxLength={255}
                />
              </div>
              {errors.suggestion_title && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.suggestion_title}
                </div>
              )}
            </div>

            {/* Suggestion Description */}
            <div className="form-group">
              <label>Suggestion Description *</label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-edit"></i>
                </div>
                <textarea
                  name="suggestion_description"
                  className={`form-input ${
                    errors.suggestion_description ? "error" : ""
                  }`}
                  placeholder="Describe your suggestion in detail..."
                  value={formData.suggestion_description}
                  onChange={handleChange}
                  rows="4"
                />
              </div>
              {errors.suggestion_description && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.suggestion_description}
                </div>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="login-button"
              disabled={submitting}
            >
              <i className="fas fa-paper-plane"></i>
              {submitting ? "Submitting..." : "Submit Suggestion"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Suggestion;
